import styled from 'styled-components'
import { lightGray, softGray, blue } from '../../styles/variables.js'
import { fieldLabel } from '../../styles/common'

const ImageUpload = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  ${fieldLabel}
`

const ImageContainer = styled.div`
  border: 1px solid ${lightGray};
  &.error {
    border: 1px solid red;
  }
  border-radius: 6px;
  overflow: hidden;
  height: ${({ height }) => height ? `${height}px` : '150px'};
  width: ${({ width }) => width ? `${width}px` : '100%'};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  ${({ readOnly }) => readOnly ? '' :
    `
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
  `}

  @media (max-width: 1120px) {
    min-width: auto;
    height: ${({ mobileHeight }) => mobileHeight ? `${mobileHeight}px` : '150px'};
    width: ${({ mobileWidth }) => mobileWidth ? `${mobileWidth}px` : '100%'};
  }

  ${({ noBorder }) => noBorder ? `
    background: ${softGray};
    border: none;
    border-radius: 0;
  ` : ''}
`

const UploadPlaceholder = styled.div`
  color: ${lightGray};
`

const ErrorLabel = styled.label`
  position: absolute;
  bottom: -26px;
  color: red !important;
  margin-top: 4px;
`

const DeleteImage = styled.div`
  text-align: end;
  cursor: pointer;
  color: ${blue};
  &:hover {
    opacity: 0.7;
  }
`

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;

  @media (max-width: 1120px) {
    min-width: auto;
    flex-direction: column;
  }
`

const FileParams = styled.label`
  font-size: 12px !important;
`

export default {
  ImageUpload,
  ImageContainer,
  UploadPlaceholder,
  ErrorLabel,
  DeleteImage,
  Header,
  FileParams,
}
